import { redirect } from "@tanstack/react-router";
import { fetchMe } from "../app/auth/session.js";
import type { RouterContext } from "./router.js";

/**
 * The admin console is for platform admins only (ART-316): anyone else who lands on `/admin` (a typed URL, a
 * shared link) is sent to their app instead of being shown an empty console. Every admin read already 403s for
 * them server-side, so this is the door, not the fence. Fails CLOSED on a `/me` error, unlike the guards above:
 * the cost of a wrong redirect is one click back, where the alternative is the empty shell this exists to remove.
 */
export async function sendNonAdminsHome(context: RouterContext): Promise<void> {
  let isAdmin = false;
  try {
    const me = await context.queryClient.ensureQueryData({ queryKey: ["me"], queryFn: () => fetchMe(context.api) });
    isAdmin = !!me.isPlatformAdmin;
  } catch {
    isAdmin = false;
  }
  if (!isAdmin) throw redirect({ to: "/" });
}
